import { REQUEST } from '@/constants/api';

import {
  ProcessIdmissionResultRequestParams,
  ProcessIdmissionResultRequestPayload,
} from '@/types/api/verification';

import { buildRequestParams } from '@/utils/api';

import { axios } from './axios';

export const initIdmissionSession = async () => {
  const result = await axios.post(REQUEST.VERIFICATION.INIT_IDMISSION_SESSION);

  return result.data;
};

export const submitIdmissionResult = async (
  payload: ProcessIdmissionResultRequestPayload,
  params?: ProcessIdmissionResultRequestParams,
) => {
  const result = await axios.post(
    `${REQUEST.VERIFICATION.PROCESS_IDMISSION_RESULT}${buildRequestParams(params)}`,
    payload,
  );

  return result.data;
};
